import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { HTMLAttributes, ReactNode } from "react";

interface ScrollSectionProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  as?: keyof JSX.IntrinsicElements;
}

const ScrollSection = ({ children, className = "", as: Tag = "div", ...rest }: ScrollSectionProps) => {
  const ref = useScrollAnimation<HTMLElement>();

  return (
    // @ts-ignore – dynamic tag
    <Tag ref={ref} className={`scroll-section ${className}`} {...rest}>
      {children}
    </Tag>
  );
};

export default ScrollSection;
